import React, { useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import {
  Modal,
  Backdrop,
  Fade,
  IconButton,
  TextField,
  Button,
} from "@material-ui/core";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";

import EditIcon from "@material-ui/icons/Edit";
import { ucitajOkruge_okrug } from "../../generated/ucitajOkruge";

export const IZMENI_OKRUG = gql`
  mutation izmeniOkrug($naziv: String, $_id: ID) {
    izmeniOkrug(_id: $_id, naziv: $naziv) {
      _id
    }
  }
`;

type PropTypes = {
  zaIzmenu: ucitajOkruge_okrug;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalForm: {
      width: 400,
      margin: "auto",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 400,
      },
    },
    button: {
      margin: theme.spacing(1),
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  })
);

export default function IzmeniOkrug(props: PropTypes) {
  const resetOkruge = {
    naziv: props.zaIzmenu.naziv,
  };
  const classes = useStyles();

  const [izmeniOkrug] = useMutation(IZMENI_OKRUG);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [buduciPodaci, setBuduciPodaci] = useState(resetOkruge);

  function otvoriFormuZaIzmenuOkruge() {
    setModalOpen(true);
  }

  function izmeniPodatkeOkruge(event: React.FormEvent) {
    event.preventDefault();
    izmeniOkrug({
      variables: {
        _id: props.zaIzmenu._id,
        naziv: buduciPodaci.naziv,
      },
      refetchQueries: ["ucitajOkruge"],
    });
    setModalOpen(false);
  }

  const onemogucenoDugme = buduciPodaci.naziv === "";

  return (
    <>
      <IconButton
        onClick={() => {
          otvoriFormuZaIzmenuOkruge();
        }}
      >
        <EditIcon />
      </IconButton>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalOpen}>
          <div className={classes.paper}>
            <form
              className={classes.modalForm}
              noValidate
              autoComplete="off"
              onSubmit={(e: React.FormEvent) => {
                izmeniPodatkeOkruge(e);
              }}
            >
              <div>
                <TextField
                  id="nazivZaIzmenu"
                  label="Naziv"
                  variant="outlined"
                  fullWidth
                  value={buduciPodaci.naziv}
                  onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setBuduciPodaci({
                      ...buduciPodaci,
                      naziv: e.target.value,
                    })
                  }
                />
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  type="submit"
                  disabled={onemogucenoDugme}
                >
                  Izmeni Okrug
                </Button>
              </div>
            </form>
          </div>
        </Fade>
      </Modal>
    </>
  );
}
